(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stooly-offer-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('stooly-offer-banner')) return;

    const FS_MAX = 14;    /* taille normale (px) */
    const FS_MIN = 11;    /* taille minimale (px) */
    const FS_STEP = 0.5;
    const COPY_DELAY = 1600;
    const desktop = window.matchMedia('(min-width: 1000px)');

    /* ---------- Compte à rebours (heure de Paris) ---------- */
    const parisFmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
    });
    const parisParts = (d) => parisFmt.formatToParts(d).reduce((a, x) => { a[x.type] = x.value; return a; }, {});
    const parisDay = (p) => Date.UTC(+p.year, +p.month - 1, +p.day);

    const LIVE_MS = 6 * 3600000;        /* « Dernières heures » : 6 h avant la fin */
    const MAX_TIMEOUT = 2147483647;     /* limite de setTimeout (~24,8 jours) */

    /* Renvoie [texte, urgent, dernières heures] */
    function dateLabel(end, now) {
      const e = parisParts(end);
      const days = Math.round((parisDay(e) - parisDay(parisParts(now))) / 86400000);
      if (end - now <= LIVE_MS) return ['Dernières heures', true, true];
      if (days <= 0) return ['Dernier jour', true, false];
      if (days === 1) return ['Plus que 2 jours', false, false];
      if (days === 2) return ['Plus que 3 jours', false, false];
      return [`Jusqu'au ${e.day}/${e.month}`, false, false];
    }

    /* Prochaine mise à jour : début des dernières heures, fin de l'offre,
       ou au plus tard dans 1 h (pour le passage de minuit) */
    function nextChange(end, now) {
      const next = Math.min(3600000, ...[end - now, end - LIVE_MS - now].filter((d) => d > 0));
      return Math.min(next + 1000, MAX_TIMEOUT);
    }

    /* ---------- Un seul observateur pour tous les bandeaux ---------- */
    const ro = 'ResizeObserver' in window
      ? new ResizeObserver((entries) => {
          for (const { target, contentRect } of entries) {
            const w = Math.round(contentRect.width);
            if (target.__stoolyW === w) continue;
            target.__stoolyW = w;
            for (const el of target.children) {
              if (el.localName === 'stooly-offer-banner') el.fit();
            }
          }
        })
      : null;

    const fitAll = () => document.querySelectorAll('stooly-offer-banner').forEach((b) => b.fit());
    if (!ro) window.addEventListener('resize', fitAll, { passive: true });
    desktop.addEventListener?.('change', fitAll);
    document.fonts?.ready.then(fitAll);

    /* ---------- Copie ---------- */
    function copyText(text) {
      if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text);
      return new Promise((resolve, reject) => {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        ta.remove();
        ok ? resolve() : reject();
      });
    }

    /* ---------- Composant ---------- */
    class StoolyOfferBanner extends HTMLElement {
      connectedCallback() {
        if (!this._init) {
          this._init = true;
          this.addEventListener('click', this);
          if (!this.setupDate()) return;
        }
        this._parent = this.parentElement;
        if (ro && this._parent) ro.observe(this._parent);
        this.fit();
      }

      disconnectedCallback() {
        if (ro && this._parent) ro.unobserve(this._parent);
        this._parent = null;
        clearTimeout(this._timer);
        this._init = false; /* réinitialisé (et minuteur relancé) s'il est réinséré */
      }

      /* Met à jour la date ; renvoie false si l'offre est terminée */
      setupDate() {
        const ts = parseInt(this.dataset.endTs, 10);
        const wrap = this.querySelector('.stooly-offre-date');
        if (!ts || !wrap) return true;

        const end = new Date(ts * 1000);
        const now = new Date();
        clearTimeout(this._timer);

        if (end <= now) {
          this.dataset.expired = '';
          this.hidden = true;
          return false;
        }

        const [text, urgent, live] = dateLabel(end, now);
        wrap.querySelector('.stooly-offre-date-text').textContent = text;
        this.classList.toggle('is-urgent', urgent);
        this.classList.toggle('is-live', live);
        wrap.hidden = false;

        /* Mise à jour automatique sans recharger la page */
        this._timer = setTimeout(() => {
          if (this.setupDate()) this.fit();
        }, nextChange(end, now));
        return true;
      }

      fits() {
        return this.scrollWidth <= this.clientWidth;
      }

      /* Réduit le texte jusqu'à ce que tout tienne ; renvoie true si c'est le cas */
      shrink() {
        let fs = Math.min(FS_MAX - FS_STEP, Math.floor((FS_MAX * this.clientWidth) / this.scrollWidth / FS_STEP) * FS_STEP);
        for (; fs >= FS_MIN; fs -= FS_STEP) {
          this.style.setProperty('--stooly-fs', `${fs}px`);
          if (this.fits()) return true;
        }
        this.style.setProperty('--stooly-fs', `${FS_MAX}px`);
        return false;
      }

      fit() {
        if (this.hidden) return;
        const { classList, style } = this;
        classList.remove('is-compact', 'is-stacked', 'is-wrapped');
        style.setProperty('--stooly-fs', `${FS_MAX}px`);

        if (!this.clientWidth || this.fits()) return; /* invisible (tiroir fermé) ou tient déjà */

        classList.add('is-compact');
        if (this.fits()) return;

        /* Ordinateur : avant de réduire, disposition sur deux lignes */
        if (desktop.matches) {
          classList.add('is-stacked');
          if (this.fits()) return;
        }

        if (this.shrink()) return;
        classList.add('is-wrapped');
      }

      setVariant(id) {
        if ('expired' in this.dataset || !this.dataset.variants) return;
        if (!this._map) {
          try { this._map = JSON.parse(this.dataset.variants); } catch (e) { return; }
        }
        if (!Object.prototype.hasOwnProperty.call(this._map, id)) return;
        this.hidden = !this._map[id];
        this.fit();
      }

      handleEvent(ev) {
        const btn = ev.target.closest('.stooly-copy-btn');
        if (!btn) return;
        const wrapper = btn.parentElement;
        if (wrapper.classList.contains('is-copied')) return;

        copyText(btn.dataset.stoolyCopy).then(() => {
          const pill = btn.querySelector('.stooly-code');
          const feedback = wrapper.querySelector('.stooly-copy-feedback');
          const original = pill.textContent;
          const w = pill.offsetWidth;

          wrapper.classList.add('is-copied');
          if (feedback) feedback.textContent = 'Code copié';
          pill.style.minWidth = `${w}px`;
          pill.textContent = 'Copié';
          if (pill.offsetWidth > w) pill.textContent = original; /* code très court : la coche suffit */

          setTimeout(() => {
            wrapper.classList.remove('is-copied');
            pill.textContent = original;
            pill.style.minWidth = '';
            if (feedback) feedback.textContent = '';
          }, COPY_DELAY);
        }).catch(() => {});
      }
    }

    customElements.define('stooly-offer-banner', StoolyOfferBanner);

    /* ---------- Changement de variante (fiche produit) ---------- */
    const applyVariant = (id) => {
      if (!id) return;
      document.querySelectorAll('stooly-offer-banner[data-variants]').forEach((b) => b.setVariant(String(id)));
    };

    let pending = 0;
    const readSelectedVariant = () => {
      if (pending || !document.querySelector('stooly-offer-banner[data-variants]')) return;
      pending = setTimeout(() => {
        pending = 0;
        applyVariant(new URLSearchParams(location.search).get('variant'));
        document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach((f) => applyVariant(f.value));
      }, 50);
    };

    document.addEventListener('variant:change', (ev) => {
      const id = ev.detail?.variant?.id;
      id ? applyVariant(id) : readSelectedVariant();
    });
    document.addEventListener('change', readSelectedVariant);
    window.addEventListener('popstate', readSelectedVariant);
  })();
  } catch(e) { console.error(e); }
})();

})();
